import { render, staticRenderFns } from "./RecentUserList.vue?vue&type=template&id=de0924a4&scoped=true"
import script from "./RecentUserList.vue?vue&type=script&lang=js"
export * from "./RecentUserList.vue?vue&type=script&lang=js"
import style0 from "./RecentUserList.vue?vue&type=style&index=0&id=de0924a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0924a4",
  null
  
)

export default component.exports